import {
  JoonColorExpanded,
  SPACING,
  WarningTriangleIcon,
} from "@joonapp/web-shared"
import { FlexBox, JoonUIColor, Typography } from "@joonapp/web-shared"
import dayjs from "dayjs"

import { useCoachingSubscriptionQuery } from "../../networking/coachingGroups/queries"
import { CoachingSubscriptionStatus } from "../../types"

const PaymentFailedHeader = () => {
  const { data: clientSubscriptionInfo, isLoading } =
    useCoachingSubscriptionQuery()

  const hasFailedPayment =
    clientSubscriptionInfo?.status === CoachingSubscriptionStatus.EXPIRED

  const periodEndDate = dayjs(clientSubscriptionInfo?.active_period_end_date)
  const periodStartDate = periodEndDate.subtract(1, "month")

  if (isLoading || (clientSubscriptionInfo && !hasFailedPayment)) return null

  return (
    <FlexBox
      style={{
        background: JoonColorExpanded.red100,
        padding: `${SPACING.space3} ${SPACING.space4}`,
      }}
      align="center"
      wrap={false}
      gap={SPACING.space2}
    >
      <WarningTriangleIcon color={JoonUIColor.semantic.alert} />
      <div>
        <Typography
          variant="bodySmallBold"
          color={JoonUIColor.semantic.alert}
          textAlign="left"
        >
          Payment failed for current period ({periodStartDate.format("MMM D")} -{" "}
          {periodEndDate.format("MMM D")}).{" "}
        </Typography>
        <Typography variant="bodySmall" color={JoonUIColor.semantic.alert}>
          Subscription is inactive until client pays. Please do not contact or
          meet with the client.
        </Typography>
      </div>
    </FlexBox>
  )
}

export default PaymentFailedHeader
